export default __webpack_public_path__ + "static/media/vire9.a122c704.jpg";